module.exports = __webpack_public_path__ + "static/img/render2.38cc8d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/render2.jpg
// module id = 5WIU
// module chunks = 0